'use strict';

/**
 * ShapeMarker is similar to a L.DivIcon except that the outer div can be
 * customized to be either a circle or variation of rectangle and the inner
 * content is either a font awesome icon class, number, or combination of 2
 * letters rather than custom HTML.
 */

/* globals document: false */

L.ShapeMarker = {
  defaultColor: '#217BC9',
  defaultIcon: 'circle',
  defaultIconColor: '#fff',
  defaultMarkerShape: 'circle',
  defaultSize: 'm',
  defaultOffset: [0, 0], // xy offset for anchor
  sizes: {
    s: {
      iconSize: 9,
      markerSize: [14, 14],
    },
    m: {
      iconSize: 12,
      markerSize: [20, 20]
    },
    l: {
      iconSize: 14,
      markerSize: [24, 24]
    }
  }
};

L.ShapeMarker.Icon = L.DivIcon.extend({

  options: {
    border: false,
    // short or long form hex color code
    color: L.ShapeMarker.defaultColor,
    // Any font awesome icon class, number, or combination of 2 characters
    icon: L.ShapeMarker.defaultIcon,
    // short or long form hex color code
    iconColor: L.ShapeMarker.defaultIconColor,
    // 's' (small), 'm' (medium), or 'l' (large) or object
    size: L.ShapeMarker.defaultSize,
    markerShape: L.ShapeMarker.defaultMarkerShape,
    offset: L.ShapeMarker.defaultOffset,
    opacity: 1,
    shadowAnchor: null,
    shadowSize: null,
    shadowUrl: null,
    className: ''
  },

  initialize: function(options) {
    this._options = options;
    options = L.Util.setOptions(this, options);

    if (typeof options.size === 'string') {
      L.extend(options, L.ShapeMarker.sizes[options.size]);
    } else {
      L.extend(options, options.size);
    }
  },

  createIcon: function (oldIcon) {

    var marker = this._createMarker(oldIcon);
    var icon = this._createIcon();

    // add the icon
    marker.appendChild(icon);

    this._setMarkerStyles(marker);
    this._setIconStyles(icon);

    return marker;
  },

  getOptions: function () {
    return this._options;
  },

  _createMarker: function (icon) {
    var options = this.options;
    var div = (icon && icon.tagName === 'DIV') ? icon : document.createElement('div');
    var className =  ['leaflet-marker-icon', 'shape-marker'];

    if (options.className) {
      className.push(options.className);
    }

    div.innerHTML = '';
    div.className = className.join(' ');

    return div;
  },

  /**
   * NOTE: marker must be positioned 'absolute'
   */
  _setMarkerStyles: function (marker) {
    var options = this.options;
    var size = L.point(options.markerSize);
    var anchor = getAnchor(size, options);
    var className =  ['leaflet-marker-icon', 'shape-marker'];

    if (options.className) {
      className.push(options.className);
    }

    marker.className = className.join(' ');

    // set the anchor
    marker.style.marginLeft = (-anchor.x) + 'px';
    marker.style.marginTop  = (-anchor.y) + 'px';

    // set the size
    marker.style.width  = size.x + 'px';
    marker.style.height = size.y + 'px';

    // set the color
    marker.style.backgroundColor = options.color;

    if (options.markerShape === 'circle') {
      marker.style.borderRadius = '999em';
    }

    if (options.border) {
      marker.style.border = options.border;
    }

    function getAnchor (size, options) {
      var borderWidth;
      var regex = /\d+px/gi; // naive regex to get border width from border option

      if (options.border) {
        borderWidth = options.border.match(regex);
        borderWidth = parseInt(borderWidth[0].replace('px', ''));
        borderWidth = L.point(borderWidth, borderWidth).multiplyBy(2);
        size = size.add(borderWidth);
      }

      var anchor = L.point(size.divideBy(2, true));

      if (options.offset) {
        anchor = anchor.add(options.offset);
      }

      return anchor;
    }
  },

  /**
   * Create the inner icon
   *
   * @return {Object} HTML DOM element
   */
  _createIcon: function () {
    var icon, type;
    var options = this.options;

    if (options.icon) {

      if (!this._isIconHTML()) {
        icon = document.createElement('i');

        if (this._isIconClass()) {
          type = 'fa-' + options.icon;
          icon.className = ['fa', type].join(' ');
        } else {
          icon.style.fontStyle = 'normal';
          icon.style.fontWeight = 'bold';
          icon.innerHTML = options.icon;
        }
      }
      // using icon html
      else {
        var div = document.createElement('div');
        div.innerHTML = options.icon;
        icon = div.querySelector('i');
      }

    }

    return icon;
  },

  _setIconStyles: function (icon) {
    var options = this.options;
    var size = options.iconSize;

    icon.style.color = options.iconColor;
    icon.style.position = 'absolute';
    icon.style.fontSize = size + 'px';
    icon.style.left = '50%';
    icon.style.top = '50%';
    icon.style.transform = 'translate(-50%, -50%)';
  },

  _isIconClass: function () {
    var options = this.options;
    // if it starts with a number or is 1-2 characters long, it is not a class
    var regex = /^\d+$|^[a-zA-Z]{1,2}$/i;
    return !regex.test(options.icon);
  },

  _isIconHTML: function () {
    var options = this.options;
    var regex = /^<.+>.*<\/\w+>$/i; // simple html regex
    return regex.test(options.icon);
  }
});

L.ShapeMarker.icon = function(options) {
  return new L.ShapeMarker.Icon(options);
};

module.exports = L.ShapeMarker;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/leaflet/ShapeMarker.js